<app-question-template [form]="form" [question]="question">
	@if (isV2()) {
		<div class="unsupported-v2">
			<div class="unsupported-v2-banner">
				<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
					info
				</span>
				<div class="unsupported-v2-copy">
					<p class="unsupported-v2-title">
						{{ "CHECKLISTS__UNSUPPORTED_QUESTION__DESCRIPTION" | transloco }}
					</p>
					<p class="unsupported-v2-hint">
						{{ "CHECKLISTS__UNSUPPORTED_QUESTION__PLEASE_CLICK_UNDERSTAND" | transloco }}
					</p>
				</div>
			</div>

			<label class="unsupported-v2-ack">
				<input
					type="checkbox"
					class="unsupported-v2-checkbox"
					[checked]="checked"
					(change)="onAcknowledge($event)"
				/>
				<span class="unsupported-v2-ack-label">
					{{ "CHECKLISTS__UNSUPPORTED_QUESTION__I_UNDERSTAND" | transloco }}
				</span>
			</label>
		</div>
	} @else {
		<ion-item>
			<ion-label>
				{{ "CHECKLISTS__UNSUPPORTED_QUESTION__DESCRIPTION" | transloco }}
				<p>{{ "CHECKLISTS__UNSUPPORTED_QUESTION__PLEASE_CLICK_UNDERSTAND" | transloco }}</p>
			</ion-label>
		</ion-item>
		<ion-item>
			<ion-toggle (ionChange)="toggleAccept($event)" [checked]="checked" [enableOnOffLabels]="true">
				{{ "CHECKLISTS__UNSUPPORTED_QUESTION__I_UNDERSTAND" | transloco }}
			</ion-toggle>
		</ion-item>
	}
</app-question-template>
